module.exports = __webpack_public_path__ + "img/Teegeschütte.9b205c68.jpg";